import React, { useEffect, useState } from 'react';
import {
    getPendingTransactions,
    syncAllPending,
    exportPendingTransactions,
    QUEUE_CHANGED_EVENT
} from '../servicios/offlineSync';

const nombrePaciente = (item) => {
    const p = item.data?.patientData;
    if (!p) return item.type === 'DELETE_QUOTE' ? 'Eliminación de cotización' : 'Registro clínico';
    return `${p.first_name || ''} ${p.last_name || ''}`.trim() || 'Paciente sin nombre';
};

// Aviso fijo mientras haya datos guardados solo en este dispositivo
const IndicadorSincronizacion = () => {
    const [queue, setQueue] = useState(getPendingTransactions());
    const [online, setOnline] = useState(navigator.onLine);
    const [expanded, setExpanded] = useState(false);
    const [syncing, setSyncing] = useState(false);

    useEffect(() => {
        const refresh = () => setQueue(getPendingTransactions());
        const onOnline = () => setOnline(true);
        const onOffline = () => setOnline(false);
        window.addEventListener(QUEUE_CHANGED_EVENT, refresh);
        window.addEventListener('storage', refresh);
        window.addEventListener('online', onOnline);
        window.addEventListener('offline', onOffline);
        return () => {
            window.removeEventListener(QUEUE_CHANGED_EVENT, refresh);
            window.removeEventListener('storage', refresh);
            window.removeEventListener('online', onOnline);
            window.removeEventListener('offline', onOffline);
        };
    }, []);

    if (queue.length === 0) return null;

    const conError = queue.filter(t => t.lastError);
    const sinSesion = !localStorage.getItem('token');
    const estado = !online
        ? 'Sin internet: se enviarán automáticamente al volver la conexión.'
        : sinSesion
            ? 'Inicie sesión para enviarlos al servidor.'
            : conError.length > 0
                ? `${conError.length} no se pudieron enviar. Revise el detalle.`
                : 'Enviando al servidor...';

    const handleSync = async () => {
        setSyncing(true);
        try { await syncAllPending(); } finally { setSyncing(false); }
    };

    return (
        <div style={{
            position: 'fixed', bottom: 16, right: 16, zIndex: 9999, maxWidth: 420, width: 'calc(100% - 32px)',
            background: conError.length > 0 ? '#fff3cd' : '#e7f1ff',
            border: `1px solid ${conError.length > 0 ? '#ffc107' : '#0d6efd'}`,
            borderRadius: 10, boxShadow: '0 4px 16px rgba(0,0,0,0.15)', padding: '12px 14px', fontSize: 14, color: '#212529'
        }}>
            <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
                ⚠ {queue.length} registro(s) guardado(s) SOLO en este dispositivo
            </div>
            <div style={{ marginBottom: 8 }}>{estado} No borre los datos del navegador.</div>

            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <button className="btn btn-sm btn-primary" onClick={handleSync} disabled={syncing || !online || sinSesion}>
                    {syncing ? 'Enviando...' : 'Enviar ahora'}
                </button>
                <button className="btn btn-sm btn-outline-secondary" onClick={exportPendingTransactions}>
                    Descargar copia
                </button>
                <button className="btn btn-sm btn-link" onClick={() => setExpanded(e => !e)}>
                    {expanded ? 'Ocultar detalle' : 'Ver detalle'}
                </button>
            </div>

            {expanded && (
                <ul style={{ margin: '8px 0 0', paddingLeft: 18, maxHeight: 200, overflowY: 'auto' }}>
                    {queue.map(item => (
                        <li key={item.id} style={{ marginBottom: 6 }}>
                            <strong>{nombrePaciente(item)}</strong>{' '}
                            <span style={{ color: '#6c757d' }}>({new Date(item.timestamp).toLocaleString()})</span>
                            {item.lastError && (
                                <div style={{ color: '#b02a37', fontSize: 12, wordBreak: 'break-word' }}>{item.lastError}</div>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default IndicadorSincronizacion;
